import cn from 'classnames'
import React from 'react'
import { CTATheme } from '../../utils'
import { CTAButton } from '../CTAButton'
import { CTALink } from '../CTALink'
import { IProps } from './index'

export const TabPill: React.FC<IProps> = ({
  text,
  url,
  eventContext,
  eventObjectName,
  isActive,
  onClick = () => {},
}) => {
  const tabPillclassNames = cn('tab-pill', {
    'tab-pill--active': isActive,
  })

  return (
    <>
      <div className={tabPillclassNames} data-testid="tab-pill">
        {url ? (
          <CTALink
            bgColor={isActive ? CTATheme.WhiteFill : CTATheme.LinkOnlyBlack}
            url={url}
            text={text}
            arrow={false}
            eventContext={eventContext}
            eventObjectName={eventObjectName}
          />
        ) : (
          <CTAButton
            bgColor={isActive ? CTATheme.WhiteFill : CTATheme.LinkOnlyBlack}
            text={text}
            onClick={onClick}
            arrow={false}
            eventContext={eventContext}
          />
        )}
      </div>
      <style jsx>{`
        .tab-pill {
          :global(.cta-link--white-fill) {
            padding: 11px 24px;

            @include media-query(mobile) {
              padding: 9px 18px;
            }
          }
        }
      `}</style>
    </>
  )
}
